import React from 'react';
import { Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

const CardDetailsPage: React.FC = () => {
  const { cardId } = useParams();
  
  return (
    <Container>
      <Typography variant="h4">Card Details</Typography>
      <Typography>Card ID: {cardId}</Typography>
    </Container>
  );
};

export default CardDetailsPage;